import script from "./WidgetProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetProfile.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetProfile.vue?vue&type=style&index=0&id=25a847f2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a847f2"]])

export default __exports__